import React from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import Building from "../../Assets/Image/building.png";
import perisai from "../../Assets/Logo/Peris.ai.png";
import perisaiBackground from "../../Assets/Image/product-background-perisai.png";
import ProductCards from "./components/ProductCards";
import Ourproducts from "../../Assets/Image/OurProduct.png";

import PerisaiLogo from "../../Assets/Logo/Perisai_gelap.png";
import ImpervaLogo from "../../Assets/Logo/imperva.png";
import CoreroLogo from "../../Assets/Logo/corero.png";
import OpenTextLogo from "../../Assets/Logo/Opentext.png";
import DellLogo from "../../Assets/Logo/Dell.png";
import AssistXLogo from "../../Assets/Logo/AssistX.png";
import FortinetLogo from "../../Assets/Logo/Fortinet.png";
import EfficientIPLogo from "../../Assets/Logo/Efficientip.png";
import GigamonLogo from "../../Assets/Logo/Gigamon.png";
import KongLogo from "../../Assets/Logo/Kong.png";
import SangforLogo from "../../Assets/Logo/Sangfor.png";
import LacakLogo from "../../Assets/Logo/lacakio.png";
import H3CLogo from "../../Assets/Logo/h3c.png";
import ZScalerLogo from "../../Assets/Logo/zscaler.png";

import PerisaiModal from "../../Assets/Product/1.png";
import ImpervaModal from "../../Assets/Product/2.png";
import CoreroModal from "../../Assets/Product/3.png";
import OpenTextModal from "../../Assets/Product/4.png";
import DellModal from "../../Assets/Product/5.png";
import AssistXModal from "../../Assets/Product/6.png";
import FortinetModal from "../../Assets/Product/7.png";
import EfficientIPModal from "../../Assets/Product/8.png";
import GigamonModal from "../../Assets/Product/9.png";
import KongModal from "../../Assets/Product/10.png";
import SangforModal from "../../Assets/Product/11.png";
import LacakModal from "../../Assets/Product/12.png";
import H3CModal from "../../Assets/Product/13.png";
import ZScalerModal from "../../Assets/Product/14.png";

const products = [
  {
    logo: ImpervaLogo,
    name: "Imperva",
    category: "Cybersecurity",
    description:
      "Imperva protects critical applications and sensitive data from cyberattacks, unauthorized access, and digital threats.",
    modalUrl: ImpervaModal,
  },
  {
    logo: PerisaiLogo,
    name: "Peris.ai",
    category: "Cybersecurity",
    description:
      "Peris.ai is an Indonesian cybersecurity company delivering AI-powered protection for modern digital environments.",
    modalUrl: PerisaiModal,
  },
  {
    logo: DellLogo,
    name: "Dell Technologies",
    category: "Infrastructure",
    description:
      "Dell Technologies provides enterprise hardware, servers, storage, endpoint devices, and data center infrastructure.",
    modalUrl: DellModal,
  },
  {
    logo: CoreroLogo,
    name: "Corero",
    category: "Cybersecurity",
    description:
      "Corero specializes in automated and real-time DDoS protection for internet-facing infrastructure and services.",
    modalUrl: CoreroModal,
  },
  {
    logo: OpenTextLogo,
    name: "OpenText",
    category: "Enterprise Software",
    description:
      "OpenText provides information management, cybersecurity, analytics, and enterprise content solutions.",
    modalUrl: OpenTextModal,
  },
  {
    logo: AssistXLogo,
    name: "AssistX Enterprise",
    category: "AI & Analytics",
    description:
      "AssistX Enterprise uses AI to automate data processing and video analytics for better operational efficiency.",
    modalUrl: AssistXModal,
  },
  {
    logo: FortinetLogo,
    name: "Fortinet",
    category: "Cybersecurity",
    description:
      "Fortinet delivers integrated security solutions including firewalls, endpoint protection, and security analytics.",
    modalUrl: FortinetModal,
  },
  {
    logo: EfficientIPLogo,
    name: "EfficientIP",
    category: "Networking",
    description:
      "EfficientIP provides DDI solutions covering DNS, DHCP, and IP address management for secure network automation.",
    modalUrl: EfficientIPModal,
  },
  {
    logo: GigamonLogo,
    name: "Gigamon",
    category: "Networking",
    description:
      "Gigamon delivers network-derived intelligence and visibility for security, observability, and cloud operations.",
    modalUrl: GigamonModal,
  },
  {
    logo: KongLogo,
    name: "Kong",
    category: "Application Platform",
    description:
      "Kong provides API management and security platforms for modern applications, microservices, and cloud-native systems.",
    modalUrl: KongModal,
  },
  {
    logo: SangforLogo,
    name: "Sangfor",
    category: "Infrastructure",
    description:
      "Sangfor provides cybersecurity, cloud, and IT infrastructure solutions for enterprise environments.",
    modalUrl: SangforModal,
  },
  {
    logo: LacakLogo,
    name: "Lacak.io",
    category: "IoT",
    description:
      "Lacak.io provides IoT fleet monitoring, vehicle tracking, fuel monitoring, and logistics visibility solutions.",
    modalUrl: LacakModal,
  },
  {
    logo: H3CLogo,
    name: "H3C",
    category: "Infrastructure",
    description:
      "H3C provides networking, cloud computing, security, and enterprise infrastructure solutions.",
    modalUrl: H3CModal,
  },
  {
    logo: ZScalerLogo,
    name: "Zscaler",
    category: "Cybersecurity",
    description:
      "Zscaler delivers cloud-based Zero Trust security for secure application access without traditional VPN dependency.",
    modalUrl: ZScalerModal,
  },
];

const categories = [
  "All",
  "Cybersecurity",
  "Infrastructure",
  "Networking",
  "Enterprise Software",
  "AI & Analytics",
  "Application Platform",
  "IoT",
];

const solutionPillars = [
  {
    title: "Cybersecurity",
    description:
      "Protect applications, data, users, networks, and digital services against evolving threats.",
  },
  {
    title: "Infrastructure",
    description:
      "Build reliable compute, storage, cloud, and data center environments for enterprise workloads.",
  },
  {
    title: "Network & Visibility",
    description:
      "Improve connectivity, observability, automation, and operational control across complex environments.",
  },
  {
    title: "Application Platforms",
    description:
      "Support modern applications, APIs, analytics, automation, and digital business processes.",
  },
];

export default function Product() {
  const [activeCategory, setActiveCategory] = React.useState("All");
  const [visibleCount, setVisibleCount] = React.useState(6);

  React.useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 80,
    });
  }, []);

  React.useEffect(() => {
    setVisibleCount(6);
  }, [activeCategory]);

  const filteredProducts =
    activeCategory === "All"
      ? products
      : products.filter((product) => product.category === activeCategory);

  const visibleProducts = filteredProducts.slice(0, visibleCount);

  return (
    <main className="overflow-hidden bg-white text-slate-900">
      {/* Hero */}
      <section className="px-4 pt-4 sm:px-6 lg:px-8">
        <div
          className="relative min-h-[620px] overflow-hidden rounded-[28px] bg-cover bg-center shadow-[0_30px_80px_rgba(15,44,72,0.22)] lg:min-h-[690px]"
          style={{ backgroundImage: `url(${Building})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#071C33]/95 via-[#123A60]/88 to-[#123A60]/35" />
          <div className="absolute -right-28 top-20 h-96 w-96 rounded-full bg-[#2392D0]/20 blur-3xl" />
          <div className="absolute -bottom-40 left-1/3 h-96 w-96 rounded-full bg-white/10 blur-3xl" />

          <div className="relative z-10 mx-auto flex min-h-[620px] max-w-7xl items-center px-6 py-24 sm:px-10 lg:min-h-[690px] lg:px-16">
            <div className="max-w-3xl" data-aos="fade-up">
              <div className="mb-6 inline-flex items-center gap-3 rounded-full border border-white/20 bg-white/10 px-4 py-2 backdrop-blur-md">
                <span className="h-2.5 w-2.5 rounded-full bg-[#42B6F5]" />
                <span className="text-sm font-semibold uppercase tracking-[0.18em] text-white/90">
                  Technology Portfolio
                </span>
              </div>

              <h1 className="text-4xl font-semibold leading-tight text-white sm:text-5xl lg:text-7xl">
                Trusted technology for
                <span className="block text-[#58BFF4]">modern enterprises.</span>
              </h1>

              <p className="mt-7 max-w-2xl text-base leading-8 text-slate-200 sm:text-lg">
                Explore our portfolio of cybersecurity, infrastructure,
                networking, cloud, data, and application technologies from
                trusted global and local principals.
              </p>

              <div className="mt-10 flex flex-col gap-4 sm:flex-row">
                <a
                  href="#product-catalog"
                  className="inline-flex items-center justify-center gap-3 rounded-full bg-[#2392D0] px-7 py-3.5 text-sm font-semibold text-white shadow-lg shadow-[#2392D0]/25 transition duration-300 hover:-translate-y-1 hover:bg-[#1D82BB]"
                >
                  Explore Products
                  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
                    <path
                      d="M12 5v14M6 13l6 6 6-6"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>

                <Link
                  to="/#contact"
                  className="inline-flex items-center justify-center rounded-full border border-white/30 bg-white/10 px-7 py-3.5 text-sm font-semibold text-white backdrop-blur-md transition duration-300 hover:bg-white hover:text-[#123A60]"
                >
                  Discuss Your Requirements
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Solution pillars */}
      <section className="mx-auto max-w-7xl px-5 py-24 sm:px-6 lg:px-8 lg:py-28">
        <div className="mx-auto max-w-3xl text-center" data-aos="fade-up">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#2392D0]">
            Solution Ecosystem
          </p>
          <h2 className="mt-4 text-3xl font-semibold leading-tight text-[#123A60] sm:text-4xl lg:text-5xl">
            Technology selected around business outcomes.
          </h2>
          <p className="mt-6 leading-8 text-slate-600">
            Our portfolio combines leading technologies with implementation,
            integration, and operational support from Viktorindo.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {solutionPillars.map((pillar, index) => (
            <article
              key={pillar.title}
              className="group rounded-[24px] border border-slate-200 bg-white p-7 shadow-sm transition duration-300 hover:-translate-y-2 hover:shadow-[0_24px_60px_rgba(18,58,96,0.14)]"
              data-aos="fade-up"
              data-aos-delay={index * 80}
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#E8F5FC] text-sm font-bold text-[#2392D0] transition duration-300 group-hover:bg-[#2392D0] group-hover:text-white">
                0{index + 1}
              </div>
              <h3 className="mt-6 text-xl font-semibold text-[#123A60]">
                {pillar.title}
              </h3>
              <p className="mt-4 leading-7 text-slate-600">
                {pillar.description}
              </p>
            </article>
          ))}
        </div>
      </section>

      {/* Featured Peris.ai */}
      <section className="px-4 pb-24 sm:px-6 lg:px-8 lg:pb-32">
        <div
          className="relative mx-auto max-w-7xl overflow-hidden rounded-[32px] bg-cover bg-center px-6 py-14 shadow-[0_30px_80px_rgba(18,58,96,0.22)] sm:px-10 lg:px-16 lg:py-20"
          style={{ backgroundImage: `url(${perisaiBackground})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#071C33]/96 via-[#123A60]/90 to-[#123A60]/58" />
          <div className="absolute -right-20 -top-20 h-80 w-80 rounded-full bg-[#2392D0]/20 blur-3xl" />

          <div className="relative z-10 grid items-center gap-12 lg:grid-cols-[0.9fr_1.1fr]">
            <div data-aos="fade-right">
              <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#58BFF4]">
                Featured Technology
              </p>
              <h2 className="mt-4 text-3xl font-semibold leading-tight text-white sm:text-4xl lg:text-5xl">
                AI-powered cybersecurity from Peris.ai.
              </h2>
              <p className="mt-6 leading-8 text-slate-200">
                Peris.ai combines machine learning, threat intelligence, and
                cybersecurity expertise to provide proactive protection against
                known and emerging digital threats.
              </p>
              <p className="mt-4 leading-8 text-slate-200">
                Built by experienced cybersecurity professionals, Peris.ai helps
                organizations strengthen digital resilience through accessible,
                efficient, and intelligent security capabilities.
              </p>

              <a
                href="https://peris.ai/"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex items-center gap-3 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-[#123A60] transition duration-300 hover:-translate-y-1 hover:shadow-xl"
              >
                Visit Peris.ai
                <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
                  <path
                    d="M14 5h5v5M10 14 19 5M19 13v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </div>

            <div
              className="flex min-h-[320px] items-center justify-center rounded-[28px] border border-white/15 bg-white/10 p-8 backdrop-blur-md sm:min-h-[400px]"
              data-aos="fade-left"
            >
              <img
                src={perisai}
                alt="Peris.ai cybersecurity"
                className="max-h-64 w-full object-contain sm:max-h-80"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Product catalog */}
      <section id="product-catalog" className="bg-[#F4F8FC] py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
            <div className="max-w-3xl" data-aos="fade-up">
              <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#2392D0]">
                Product Catalog
              </p>
              <h2 className="mt-4 text-3xl font-semibold leading-tight text-[#123A60] sm:text-4xl lg:text-5xl">
                Explore our technology principals and solutions.
              </h2>
              <p className="mt-6 leading-8 text-slate-600">
                Select a category to find technologies aligned with your
                infrastructure, security, networking, or application needs.
              </p>
            </div>
          </div>

          <div className="mt-10 flex flex-wrap gap-3" data-aos="fade-up">
            {categories.map((category) => {
              const isActive = activeCategory === category;

              return (
                <button
                  key={category}
                  type="button"
                  onClick={() => setActiveCategory(category)}
                  className={`rounded-full px-5 py-2.5 text-sm font-semibold transition duration-300 ${
                    isActive
                      ? "bg-[#123A60] text-white shadow-lg shadow-[#123A60]/20"
                      : "border border-slate-200 bg-white text-slate-600 hover:border-[#2392D0] hover:text-[#2173AA]"
                  }`}
                >
                  {category}
                </button>
              );
            })}
          </div>

          <div className="mt-12 grid grid-cols-1 gap-7 md:grid-cols-2 xl:grid-cols-3">
            {visibleProducts.map((product, index) => (
              <div
                key={product.name}
                data-aos="fade-up"
                data-aos-delay={(index % 3) * 80}
              >
                <ProductCards
                  logo={product.logo}
                  name={product.name}
                  description={product.description}
                  modalUrl={product.modalUrl}
                />
              </div>
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="mt-12 rounded-[24px] border border-dashed border-slate-300 bg-white p-10 text-center">
              <p className="text-lg font-semibold text-[#123A60]">
                No products found in this category.
              </p>
            </div>
          )}

          {filteredProducts.length > 6 && (
            <div className="mt-12 flex justify-center">
              {visibleCount < filteredProducts.length ? (
                <button
                  type="button"
                  onClick={() =>
                    setVisibleCount((current) =>
                      Math.min(current + 6, filteredProducts.length)
                    )
                  }
                  className="inline-flex items-center gap-3 rounded-full bg-[#2392D0] px-7 py-3.5 text-sm font-semibold text-white transition duration-300 hover:-translate-y-1 hover:bg-[#1D82BB] hover:shadow-xl"
                >
                  Load More Products
                  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
                    <path
                      d="M12 5v14M6 13l6 6 6-6"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              ) : (
                <button
                  type="button"
                  onClick={() => {
                    setVisibleCount(6);
                    document
                      .getElementById("product-catalog")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="inline-flex items-center gap-3 rounded-full border border-[#2392D0] bg-white px-7 py-3.5 text-sm font-semibold text-[#2173AA] transition duration-300 hover:-translate-y-1 hover:bg-[#E8F5FC]"
                >
                  Show Fewer Products
                  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
                    <path
                      d="M12 19V5M6 11l6-6 6 6"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              )}
            </div>
          )}
        </div>
      </section>

      {/* Other products */}
      <section className="mx-auto max-w-7xl px-5 py-24 sm:px-6 lg:px-8 lg:py-32">
        <div className="grid items-center gap-12 lg:grid-cols-[0.75fr_1.25fr] lg:gap-16">
          <div data-aos="fade-right">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#2392D0]">
              Extended Portfolio
            </p>
            <h2 className="mt-4 text-3xl font-semibold leading-tight text-[#123A60] sm:text-4xl">
              More technologies for specific business requirements.
            </h2>
            <p className="mt-6 leading-8 text-slate-600">
              Beyond our featured solutions, Viktorindo works with a broader
              technology ecosystem to support different enterprise use cases,
              industries, and implementation requirements.
            </p>
            <Link
              to="/#contact"
              className="mt-8 inline-flex items-center gap-3 font-semibold text-[#2173AA] transition hover:gap-4"
            >
              Ask About a Product
              <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
                <path
                  d="M5 12h14M13 6l6 6-6 6"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </div>

          <div
            className="overflow-hidden rounded-[28px] border border-slate-200 bg-white p-5 shadow-[0_20px_60px_rgba(18,58,96,0.10)] sm:p-8"
            data-aos="fade-left"
          >
            <img
              src={Ourproducts}
              alt="Other Viktorindo technology products"
              className="h-auto w-full object-contain"
            />
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="px-4 pb-24 sm:px-6 lg:px-8 lg:pb-32">
        <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[30px] bg-gradient-to-r from-[#123A60] to-[#2173AA] px-6 py-14 sm:px-10 lg:flex lg:items-center lg:justify-between lg:px-14">
          <div className="absolute -right-12 -top-24 h-72 w-72 rounded-full border border-white/10" />
          <div className="absolute -right-4 -top-14 h-52 w-52 rounded-full border border-white/10" />

          <div className="relative z-10 max-w-2xl">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#78CDF8]">
              Product Consultation
            </p>
            <h2 className="mt-3 text-3xl font-semibold leading-tight text-white sm:text-4xl">
              Not sure which technology fits your environment?
            </h2>
            <p className="mt-4 leading-7 text-slate-200">
              Our team can help map your requirements, compare suitable
              solutions, and prepare the right implementation approach.
            </p>
          </div>

          <div className="relative z-10 mt-8 lg:mt-0">
            <Link
              to="/#contact"
              className="inline-flex items-center justify-center gap-3 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-[#123A60] transition duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              Contact Our Team
              <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
                <path
                  d="M5 12h14M13 6l6 6-6 6"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}